jQuery(document).ready(function ($) {
    const $block = $('.wp-block-jormi-subnavigation').first();
    
    if (!$block.length) {
        return;
    }

    const $navItems = $('[data-anchor]');
    const sections = $navItems.toArray().map(item => $($(item).attr('data-anchor'))[0]);

    // Retrieve colors from data attributes
    const activeColor = $block.data('active-color');
    const defaultColor = $block.data('default-color');

    // Create placeholder for fixed positioning
    const $blockPlaceholder = $('<div class="wp-block-jormi-subnavigation__placeholder"></div>');
    $block.before($blockPlaceholder);

    let lastScroll = 0;
    let ticking = false;

    const blockOffset = $block.offset().top;

    const getOffsets = () => {
        const blockHeight = $block.outerHeight();
        const $siteHeader = $('.site-header');
        const headerHeight = $siteHeader.length ? $siteHeader.outerHeight() : 0;
        const $adminBar = $('#wpadminbar');
        const adminBarHeight = $adminBar.length ? $adminBar.outerHeight() : 0;
        
        return { blockHeight, headerHeight, adminBarHeight };
    };

    const handleNavigation = () => {
        const currentScroll = $(window).scrollTop();
        const viewportHeight = $(window).height();
        const { blockHeight, headerHeight, adminBarHeight } = getOffsets();
        const totalOffset = headerHeight + adminBarHeight + blockHeight;

        // Handle block positioning (sticky behavior)
        if (currentScroll >= blockOffset) {
            const topPosition = currentScroll > lastScroll
                ? adminBarHeight
                : headerHeight + adminBarHeight;

            $block.css({
                position: 'fixed',
                left: '0',
                right: '0',
                zIndex: '50',
                transition: 'all 0.3s ease',
                top: `${topPosition}px`,
                marginTop: '0'
            });
            
            $blockPlaceholder.css('height', `${blockHeight}px`);
        } else {
            $block.css({ position: 'static', top: '' });
            $blockPlaceholder.css('height', '0');
        }

        // Determine active section
        const activeIndex = sections.findIndex(section => {
            if (!section) return false;
            
            const $section = $(section);
            const sectionHeight = $section.outerHeight();
            const sectionTop = $section.offset().top - totalOffset;
            const sectionBottom = sectionTop + sectionHeight;

            // Active when viewport is within 10%-90% of section
            const section10PercentTop = sectionTop + (sectionHeight * 0.10);
            const section90PercentBottom = sectionBottom - (sectionHeight * 0.10);

            return currentScroll + viewportHeight > section10PercentTop && 
                   currentScroll < section90PercentBottom;
        });

        // Update nav item colors
        $navItems.each(function(index) {
            $(this).css({
                color: index === activeIndex ? activeColor : defaultColor
            });
        });

        lastScroll = currentScroll;
        ticking = false;
    };

    // Throttle scroll events with requestAnimationFrame
    $(window).on('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                handleNavigation();
            });
            ticking = true;
        }
    });

    // Smooth scroll for anchor links
    $navItems.on('click', function(e) {
        const href = $(this).attr('href');
        
        if (href && href.startsWith('#')) {
            e.preventDefault();
            const $target = $(href);
            
            if ($target.length) {
                const { headerHeight, adminBarHeight } = getOffsets();
                const blockHeight = $block.outerHeight();
                const offset = headerHeight + adminBarHeight + blockHeight;
                const targetPosition = $target.offset().top - offset;
                
                $('html, body').animate({
                    scrollTop: targetPosition
                }, 600);
            }
        }
    });

    // Initial call
    handleNavigation();
});